import { useEffect, useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { GetEquipmentsModelList } from '../../../../store/FLEET/EquipmentsModel/equipmentsmodelSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useTranslation } from 'react-i18next';
import AddManufacturer from './AddManufacturer';
import EditManufacturer from './EditManufacturer';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
 import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const [Show, setShow] = useState(false);
  const [id, setId] = useState('');
  const {HasPermission} = usePermissions()

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (EquipmentsModelList?.length === 0) {
      dispatch(GetEquipmentsModelList());
    }
  }, []);
  const { EquipmentsModelList, loading } = useAppSelector(state => state.EquipmentsModel);

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = EquipmentsModelList?.filter(f => f.parentId === null)?.map(item => {
    let rowClass;

    return {
      Name: (
        <div className='d-flex align-items-center'>
          <div className='w-50px h-50px bg-white bg-opacity-25 d-flex align-items-center justify-content-center  rounded-2'>
            {item.image === null ? (
              <img alt='' className='mw-100 mh-100' src='/assets/img/Image/NoImg2.ico' />
            ) : (
              <img alt='' className='mw-100 mh-100' src={item?.image?.filePath} />
            )}
          </div>
          <div className='ms-3'>{i18n.language === 'en' ? item.name : item.name2}</div>
        </div>
      ),

      action: (
        <>
          <button
            hidden={!HasPermission('FleetManufacturersEdit')}
            type='button'
            className='btn btn-outline-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalEditEquipmentsModel'
            onClick={() => setId(item.id)}
          >
            <i className='far fa-lg fa-fw me-2 fa-edit'></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //____________________________
  const BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'Manufacturers',
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='Manufacturers' />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddingManufacturingCompanies')}
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalِAddEquipmentsModel'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddManufacturers')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddManufacturers')} id='modalِAddEquipmentsModel' size='lg'>
        {Show && <AddManufacturer />}
      </ModalComponent>

      <ModalComponent title={t('EditManufacturers')} id='modalEditEquipmentsModel' size='lg'>
        {id && <EditManufacturer id={id} />}
      </ModalComponent>
    </>
  );
};

export default Index;
